import { useMutation } from '@tanstack/react-query';
import { systemLogsApi } from './system-logs.api';

export function useLogAuditEvent() {
  return useMutation({
    mutationFn: (data: { action: string; meta?: Record<string, unknown> }) =>
      systemLogsApi.create(data),
    // Fire-and-forget: no invalidation, no toast
    meta: {
      skipGlobalSuccessToast: true,
      skipGlobalErrorToast: true
    }
  });
}
